import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';
import { TOS_PATH, PRIVACY_PATH } from 'dpl/shared/constants/urls';

export default function StripeChargeModalFooter({ paymentMethod }) {
  const iconName = 'fetch-lock';

  return (
    <div className="StripeChargeModalFooter pt6">
      <div className="flex items-center justify-center">
        <Icon className="dib mr2" height="16px" name={iconName} width="16px" />
        <p className="f2">All transactions are secure and encrypted.</p>
      </div>
      <p className="f1 tc mt4 tertiary">
        By paying you agree to Good Dog&apos;s{' '}
        <a
          href={TOS_PATH}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Terms of Service
        </a>{' '}
        and{' '}
        <a
          href={PRIVACY_PATH}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Privacy Policy
        </a>
        .
        {paymentMethod &&
          paymentMethod === 'us_bank_account' &&
          ` Good Dog verifies your bank account details and checks your balances
            to make sure you have sufficient funds before initiating an ACH
            transaction.
          `}
      </p>
    </div>
  );
}

StripeChargeModalFooter.propTypes = {
  paymentMethod: PropTypes.string
};

StripeChargeModalFooter.defaultProps = {
  paymentMethod: null
};
